import getHelper from '../../../services/getHelper';
import type {
  JobPosting,
  PublicApplication,
  RecruiterPreselection,
  RecruiterRejection,
} from '../../../../../index';

export default getHelper<PublicApplication>('/public-applications/:id', {
  recruiterPreselections: getHelper<RecruiterPreselection>('/recruiter-preselections'),
  recruiterRejections: getHelper<RecruiterRejection>('/recruiter-rejections'),
  jobPostings: getHelper<JobPosting>('/job-posting'),
});
